import { useEffect, useState } from "react";
import { CircularProgress, Fade, Tab, Tabs, Typography } from "@mui/material";
import { useHistory, useParams } from "react-router-dom";
import { BarChart, Bar, XAxis, ResponsiveContainer } from "recharts";

import { useNotification, useUnits } from "../../../contexts";
import * as s from "./styles";
import { PageHeader } from "../../../components";
import { RUSH_LEVELS, WEEK_DAYS } from "../../../@data";

const UnitDetails = () => {
  const history = useHistory();
  const { unitId } = useParams<{ unitId?: string }>();

  const { handleNotification } = useNotification();
  const { loadingUnits, units } = useUnits();

  const [selectedDay, setSelectedDay] = useState(new Date().getDay());

  const unit = units.find((b) => b.unitId === unitId);

  const selectedWeekDay = WEEK_DAYS[selectedDay];
  let rushHoursList = (
    unit?.daysWithRushHoursList
      ? unit?.daysWithRushHoursList[selectedWeekDay.key]
      : []
  )?.map((rush) => ({ ...rush, fill: RUSH_LEVELS[rush.rushLevel].color }));

  useEffect(() => {
    if (unit === undefined && !loadingUnits) {
      history.push("/");
      handleNotification("error", "Unidade não encontrada!");
    }
  }, [unit, handleNotification, history, loadingUnits]);

  if (loadingUnits || !unit)
    return (
      <s.UnitContainer>
        <CircularProgress sx={{ margin: "auto" }} />
      </s.UnitContainer>
    );
  return (
    <Fade in timeout={1000}>
      <s.PageContainer>
        <PageHeader
          label={unit.name}
          handleBackPress={() => history.goBack()}
        />
        <s.UnitContainer>
          <s.UnitImage src={unit.imageUrl} />
          <Typography variant="caption" color="gray">
            Endereço
          </Typography>
          <Typography>{unit.address}</Typography>
          <Typography variant="caption" color="gray" sx={{ mt: 2 }}>
            Contato
          </Typography>
          <Typography>{unit.phone}</Typography>
          <Typography variant="caption" color="gray" sx={{ mt: 2 }}>
            Horários mais movimentados
          </Typography>
          <Tabs
            value={selectedDay}
            onChange={(_, newValue) => setSelectedDay(newValue)}
            centered
          >
            {WEEK_DAYS.map((day) => (
              <Tab
                label={day.label}
                key={day.key}
                sx={{ maxWidth: "14.28%", minWidth: "auto" }}
              />
            ))}
          </Tabs>
          {rushHoursList?.length ? (
            <s.GraphicContainer>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart height={500} data={rushHoursList}>
                  <XAxis dataKey="startHour" />
                  <Bar dataKey="rushLevel" minPointSize={15} barSize={20} />
                </BarChart>
              </ResponsiveContainer>
            </s.GraphicContainer>
          ) : (
            <s.NoRushHoursMessage>
              Sem informações de movimento
              <br /> para este dia.
            </s.NoRushHoursMessage>
          )}
        </s.UnitContainer>
      </s.PageContainer>
    </Fade>
  );
};

export default UnitDetails;
